const state = {
  header: true,
};

const mutations = {
  hiddenHeader(state, data) {
    state.header = data;
  },
};

const actions = {
  buscarDetalheUnidade: async (context, { unidadeId, perPage, page }) => {
    const api = context.rootState.autenticacao.api;
    let resposta = await api.get(`/pdt/unidade/${unidadeId}/atividade`, {
      params: {
        perPage: perPage,
        page: page,
      },
    });

    return resposta;
  },
  adicionarAtividade: async (
    context,
    { unidadeId, nome, critico, obrigatorio }
  ) => {
    const api = context.rootState.autenticacao.api;

    let resposta = await api.post(`/pdt/unidade/${unidadeId}/atividade`, {
      nome,
      critico,
      obrigatorio,
    });

    return resposta;
  },
  removerAtividade: async (context, { unidadeId, atividadeId }) => {
    const api = context.rootState.autenticacao.api;

    let resposta = await api.delete(
      `/pdt/unidade/${unidadeId}/atividade/${atividadeId}`,
      {}
    );

    return resposta;
  },
  buscarDetalheAtividade: async (context, { unidadeId, atividadeId }) => {
    const api = context.rootState.autenticacao.api;
    let resposta = await api.get(
      `/pdt/unidade/${unidadeId}/atividade/${atividadeId}`
    );

    return resposta;
  },
  adicionarPergunta: async (context, { unidadeId, atividadeId, pergunta }) => {
    const api = context.rootState.autenticacao.api;

    let resposta = await api.post(
      `/pdt/unidade/${unidadeId}/atividade/${atividadeId}/pergunta`,
      { descricao: pergunta }
    );

    return resposta;
  },
  removerPergunta: async (context, { unidadeId, atividadeId, perguntaId }) => {
    const api = context.rootState.autenticacao.api;

    let resposta = await api.delete(
      `/pdt/unidade/${unidadeId}/atividade/${atividadeId}/pergunta/${perguntaId}`,
      {}
    );

    return resposta;
  },
  listarEncerramento: async (context, { unidadeId }) => {
    const api = context.rootState.autenticacao.api;

    let resposta = await api.get(`/pdt/unidade/${unidadeId}/encerramento`, {});

    return resposta;
  },
  adicionarEncerramento: async (context, { unidadeId, pergunta }) => {
    const api = context.rootState.autenticacao.api;

    let resposta = await api.post(`/pdt/unidade/${unidadeId}/encerramento`, {
      pergunta,
    });

    return resposta;
  },
  removerEncerramento: async (context, { unidadeId, encerramentoId }) => {
    const api = context.rootState.autenticacao.api;

    let resposta = await api.delete(
      `/pdt/unidade/${unidadeId}/encerramento/${encerramentoId}`,
      {}
    );

    return resposta;
  },
  listarPt: async (
    context,
    { ptId, emissorNome, status, inicio, final, rowsPerPage, page, local }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get("/pdt/pt", {
      params: {
        ptId,
        emissorNome,
        status,
        local,
        rangeDataInicio: {
          inicio: inicio,
          final: final,
        },
        rowsPerPage,
        page,
      },
    });

    return response;
  },
  emitirPt: async (
    context,
    {
      unidadeId,
      modeloId,
      local,
      descricao,
      dataHoraInicio,
      dataHoraTermino,
      latitude,
      longitude,
      areaTrabalho,
      observacao,
      recomendacao,
      outrasMedidas,
      aviso,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post("/pdt/pt", {
      unidadeId,
      modeloId,
      local,
      descricao,
      dataHoraInicio,
      dataHoraTermino,
      latitude,
      longitude,
      areaTrabalho,
      observacao,
      recomendacao,
      outrasMedidas,
      aviso,
    });

    if (response.data?.resultado?.id) {
      try {
        await context.dispatch("removerEmissoresDuplicados", {
          ptId: response.data.resultado.id,
        });
      } catch (error) {
        console.error(error);
      }
    }

    return response;
  },

  removerEmissoresDuplicados: async (context, { ptId }) => {
    const api = context.rootState.autenticacao.api;

    try {
      const ptResponse = await api.get(`/pdt/pt/${ptId}`);
      const responsaveis =
        ptResponse.data?.resultado?.dados?.responsaveis || [];

      const emissores = responsaveis.filter((resp) => resp.tipo === "emissor");

      if (emissores.length > 1) {
        const emissoresDuplicados = emissores.filter(
          (e) => !e.matricula || !e.nome
        );

        for (const emissorDuplicado of emissoresDuplicados) {
          await api.delete(
            `/pdt/pt/${ptId}/responsavel/${emissorDuplicado.responsavelId}`
          );
        }
      }
    } catch (error) {
      console.error(error);
    }
  },

  adicionarResponsavelObrigatorio: async (
    context,
    { ptId, tipoResponsavel }
  ) => {
    const api = context.rootState.autenticacao.api;

    const getRealmFromUrl = () => {
      try {
        const hostname = window.location.hostname;
        const subdomain = hostname.split(".")[0];
        return subdomain || "multpex";
      } catch (e) {
        return "multpex";
      }
    };

    const realm =
      context.rootState.autenticacao?.usuarioLogado?.realm || getRealmFromUrl();

    const response = await api.post(`/pdt/pt/${ptId}/responsavel`, {
      matricula: "",
      nome: "",
      empresa: realm,
      tipo: tipoResponsavel.tipo,
      terceirizado: false,
      tipoId: tipoResponsavel.tipoReponsavelId,
      cargo: "",
      obrigatorio: true,
      pendentePadrao: true,
    });

    return response;
  },

  editarResponsavelPt: async (
    context,
    { ptId, responsavelId, matricula, nome, empresa, terceirizado, cargo }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `/pdt/pt/${ptId}/responsavel/${responsavelId}`,
      {
        matricula,
        nome,
        empresa,
        terceirizado,
        cargo,
      }
    );

    return response;
  },

  duplicarPt: async (
    context,
    { ptId, unidadeId, local, descricao, dataHoraInicio, dataHoraTermino }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/pt/${ptId}/clonar`, {
      ptId,
      unidadeId,
      local,
      descricao,
      dataHoraInicio,
      dataHoraTermino,
    });

    return response;
  },
  buscarDetalhePt: async (context, { ptId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/pdt/pt/${ptId}`);

    const cacheKey = `funcionarioCache_${
      response.data?.resultado?.dados?.unidadeId || "default"
    }`;
    let funcionarioCache;

    if (!window[cacheKey]) {
      window[cacheKey] = new Map();
    }
    funcionarioCache = window[cacheKey];

    const buscarDadosFuncionario = async (matricula) => {
      if (funcionarioCache.has(matricula)) {
        return funcionarioCache.get(matricula);
      }

      const pendingKey = `pending_${matricula}`;
      if (funcionarioCache.has(pendingKey)) {
        return await funcionarioCache.get(pendingKey);
      }

      const searchPromise = (async () => {
        try {
          const funcionarioResponse = await api.get(
            `/fun/unidade/${
              response.data?.resultado?.dados?.unidadeId || 1
            }/funcionario`,
            {
              params: {
                busca: matricula,
              },
            }
          );

          const funcionarios = funcionarioResponse.data?.resultado?.dados || [];
          const funcionario = funcionarios.find(
            (func) => func.matricula === matricula || func.sap === matricula
          );

          funcionarioCache.delete(pendingKey);
          funcionarioCache.set(matricula, funcionario || null);

          return funcionario || null;
        } catch (error) {
          console.warn("Erro ao buscar dados do funcionário:", error);
          funcionarioCache.delete(pendingKey);
          funcionarioCache.set(matricula, null);
          return null;
        }
      })();

      funcionarioCache.set(pendingKey, searchPromise);

      return await searchPromise;
    };

    // Funçao auxiliar para converter matricula baseado nos dados da API de funcionarios
    const convertMatriculaUsingSap = async (obj) => {
      if (Array.isArray(obj)) {
        const results = [];
        for (const item of obj) {
          results.push(await convertMatriculaUsingSap(item));
        }
        return results;
      } else if (obj && typeof obj === "object") {
        const newObj = {};
        for (const [key, value] of Object.entries(obj)) {
          if (key === "matricula" && value) {
            // Busca os dados completos do funcionario
            const funcionarioData = await buscarDadosFuncionario(value);
            if (funcionarioData && funcionarioData.sap) {
              // Substitui a matricula pelo sap
              newObj[key] = funcionarioData.sap;
            } else {
              newObj[key] = value; // Mantem o valor original se n encontrar
            }
          } else {
            newObj[key] = await convertMatriculaUsingSap(value);
          }
        }
        return newObj;
      }
      return obj;
    };

    // Aplica a conversao nos dados da resposta
    if (response.data) {
      response.data = await convertMatriculaUsingSap(response.data);
    }

    return response;
  },
  adicionarAtividadePt: async (context, { ptId, atividadeId, resposta }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(
      `/pdt/pt/${ptId}/atividade/${atividadeId}`,
      {
        resposta,
      }
    );

    return response;
  },
  removerAtividadePt: async (context, { ptId, atividadeId, resposta }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `/pdt/pt/${ptId}/atividade/${atividadeId}`,
      {
        resposta,
      }
    );

    return response;
  },
  responderPerguntaAtividade: async (
    context,
    { ptId, atividadeId, perguntaId, resposta, observacao }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(
      `/pdt/pt/${ptId}/atividade/${atividadeId}/pergunta/${perguntaId}`,
      {
        resposta,
        observacao,
      }
    );

    return response;
  },
  adicionarResponsavelPt: async (
    context,
    { ptId, matricula, nome, empresa, tipo, terceirizado, tipoId, cargo }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/pt/${ptId}/responsavel`, {
      matricula,
      nome,
      empresa,
      tipo,
      terceirizado,
      tipoId,
      cargo,
    });

    return response;
  },
  removerResponsavelPt: async (context, { ptId, responsavelId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `/pdt/pt/${ptId}/responsavel/${responsavelId}`,
      {}
    );

    return response;
  },
  adicionarExecutantePt: async (
    context,
    { ptId, matricula, nome, empresa, terceirizado, cargo }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/pt/${ptId}/executante`, {
      matricula,
      nome,
      empresa,
      terceirizado,
      cargo,
    });

    return response;
  },
  removerExecutantePt: async (context, { ptId, executanteId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `/pdt/pt/${ptId}/executante/${executanteId}`,
      {}
    );

    return response;
  },
  removerAnexo: async (context, { ptId, anexoId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`/pdt/pt/${ptId}/anexo/${anexoId}`);

    return response;
  },
  responderPerguntaEncerramento: async (
    context,
    { ptId, encerramentoId, resposta }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `/pdt/pt/${ptId}/encerramento/${encerramentoId}`,
      {
        resposta,
      }
    );

    return response;
  },
  finalizarEdicao: async (context, { ptId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`/pdt/pt/${ptId}/finalizar-edicao`, {});

    return response;
  },
  iniciarAtividades: async (context, { ptId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`/pdt/pt/${ptId}/iniciar-atividades`, {});

    return response;
  },
  encerrarAtividades: async (context, { ptId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`/pdt/pt/${ptId}/encerrar-atividades`, {});

    return response;
  },
  finalizar: async (context, { ptId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`/pdt/pt/${ptId}/finalizar`, {});

    return response;
  },
  getUpload: async (context, { ptId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/pdt/pt/${ptId}/assinatura/uploadUrl`);

    return response;
  },

  getImage: async (context, { url }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/common/file/signedUrl?fileUrl=${url}`);

    return response;
  },

  removerAssinatura: async (context, { ptId, assinaturaId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `/pdt/pt/${ptId}/assinatura/${assinaturaId}`
    );

    return response;
  },
  getFuncionarios: async (context, { unidade, busca }) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.get(`/fun/unidade/${unidade}/funcionario`, {
      params: {
        busca: busca,
      },
    });

    return response;
  },
  getFuncionariosTerceiros: async (context, { busca, unidadeId }) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.get(
      `/ter/unidade/${unidadeId}/parceiro/${busca}/terceiro`,
      {}
    );

    return response;
  },
  getFuncionariosParceiros: async (context, { unidadeId }) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.get(`/ter/unidade/parceiro`, {
      params: {
        unidadeId,
      },
    });

    return response;
  },
  observacaoEncerramento: async (context, { pt, observacao }) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.put(`/pdt/pt/${pt}/obs-encerramento`, {
      observacao,
    });

    return response;
  },

  getUploadAnexo: async (context, { ptId, nomeArquivo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/pdt/pt/${ptId}/anexo/uploadUrl`, {
      params: {
        nomeArquivo,
      },
    });
    return response;
  },

  enviarAnexoGeral: async (context, { ptId, url, descricao }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/pt/${ptId}/anexo/geral`, {
      url,
      descricao,
    });

    return response;
  },
  enviarAnexoEncerramento: async (context, { ptId, url, descricao }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/pt/${ptId}/anexo/encerramento`, {
      url,
      descricao,
    });

    return response;
  },
  enviarAnexoExecutante: async (context, { ptId, url, executanteId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(
      `/pdt/pt/${ptId}/anexo/executante/${executanteId}`,
      {
        url,
      }
    );

    return response;
  },
  filtrarPtLista: async (
    context,
    {
      unidadeId,
      status,
      perPage,
      page,
      inicio,
      final,
      ptId,
      emissorNome,
      local,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get("/pdt/pt", {
      params: {
        unidadeId: unidadeId,
        status: status,
        perPage: perPage,
        page,
        ptId,
        local,
        emissorNome,
        rangeDataInicio: {
          inicio: inicio,
          final: final,
        },
      },
    });

    return response;
  },
  cancelarPt: async (
    context,
    { motivo, acoesNecessarias, observacao, ptId }
  ) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.put(`/pdt/pt/${ptId}/cancelar`, {
      motivo,
      acoesNecessarias,
      observacao,
    });

    return response;
  },
  enviarAssinatura: async (
    context,
    {
      ptId,
      atividadeNome,
      assinanteId,
      assinanteTipo,
      participaAtividade,
      assinatura,
      assinaturaTipo,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/pt/${ptId}/assinatura`, {
      atividadeNome,
      assinanteId,
      assinanteTipo,
      participaAtividade,
      assinatura,
      assinaturaTipo,
    });

    return response;
  },
  enviarAssinaturaEncerramento: async (
    context,
    { assinatura, responsavelId, ptId, assinaturaTipo }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/pt/${ptId}/assinatura-encerramento`, {
      responsavelId,
      assinatura,
      assinaturaTipo,
    });

    return response;
  },

  hiddenHeader({ commit }, data) {
    commit("hiddenHeader", data);
  },
  enviarConfiguraçõesInformacao: async (
    context,
    { unidadeId, areaTrabalho, observacao, recomendacao, outrasMedidas, aviso }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/unidade/${unidadeId}/informacoes`, {
      areaTrabalho,
      observacao,
      recomendacao,
      outrasMedidas,
      aviso,
    });

    return response;
  },
  receberConfiguraçõesInformacao: async (context, { unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/pdt/unidade/${unidadeId}/informacoes`, {
      params: {
        unidadeId: unidadeId,
      },
    });

    return response;
  },

  listarTiposResponsaveis: async (context, { unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `/pdt/unidade/${unidadeId}/tipo-responsavel`,
      {
        unidadeId,
      }
    );

    return response;
  },

  adicionarTipoResponsavel: async (
    context,
    { unidadeId, tipo, obrigatorio, terceirizado }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(
      `/pdt/unidade/${unidadeId}/tipo-responsavel`,
      {
        tipo,
        obrigatorio,
        terceirizado,
      }
    );

    return response;
  },

  removerTipoResponsavel: async (context, { unidadeId, tipoResponsavelId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `/pdt/unidade/${unidadeId}/tipo-responsavel/${tipoResponsavelId}`
    );

    return response;
  },

  copiarConfiguracoes: async (context, { recebe, envia }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `/pdt/unidade/${recebe}/clonar-configuracao/unidade/${envia}`,
      {
        unidadeId1: recebe,
        unidadeId2: envia,
      }
    );

    return response;
  },

  checarStatusGeolocalizacao: async (context, { unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/pdt/unidade/${unidadeId}/geolocalizacao`, {
      params: {
        unidadeId,
      },
    });

    return response;
  },

  atualizarStatusLocalizacao: async (context, { unidadeId, ativo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`/pdt/unidade/${unidadeId}/geolocalizacao`, {
      unidadeId,
      ativo,
    });

    return response;
  },

  observacaoAvaliacao: async (context, { ptId, observacao }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`/pdt/pt/${ptId}/obs-avaliacao-risco`, {
      observacao,
    });
    return response;
  },

  retrocederStatus: async (context, { ptId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`/pdt/pt/${ptId}/retroceder-status`, {
      ptId,
    });

    return response;
  },

  uploadCsv: async (context, { unidadeId, arquivoCsv }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(
      `/pdt/unidade/${unidadeId}/atividade/upload-csv`,
      {
        arquivoCsv,
      }
    );

    return response;
  },

  adicionarObservacaoPorStatus: async (context, { ptId, observacao }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/pt/${ptId}/observacao`, {
      observacao,
    });

    return response;
  },

  adicionarObservacao: async (context, { ptId, observacao }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`/pdt/pt/${ptId}/obs-avaliacao-risco`, {
      observacao,
    });

    return response;
  },

  listarConfiguracaoGeral: async (context, { unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `/pdt/unidade/${unidadeId}/configuracao-geral`
    );
    return response;
  },

  adicionarConfiguracaoGeral: async (context, { unidadeId, tipo, valor }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(
      `/pdt/unidade/${unidadeId}/configuracao-geral`,
      {
        tipo,
        valor,
      }
    );
    return response;
  },

  listarModelos: async (context, { modeloId, unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/pdt/modelo`, {
      params: {
        modeloId,
        unidadeId,
      },
    });
    return response;
  },

  criarModelo: async (
    context,
    { modeloNome, criadorNome, criadorMatricula, unidadeId }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/modelo`, {
      modeloNome,
      criadorNome,
      criadorMatricula,
      unidadeId,
    });
    return response;
  },

  removerModelo: async (context, { modeloId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`/pdt/modelo/${modeloId}`);
    return response;
  },

  adicionarAtributoModelo: async (
    context,
    { modeloId, atributoId, atributoTipo }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/modelo/${modeloId}/atributo`, {
      atributoId,
      atributoTipo,
    });
    return response;
  },

  removerAtributoModelo: async (
    context,
    { modeloId, atributoId, atributoTipo }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`/pdt/modelo/${modeloId}/atributo`, {
      data: {
        atributoId,
        atributoTipo,
      },
    });
    return response;
  },

  duplicarModelo: async (context, { modeloId, unidadeDestinoId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`/pdt/modelo/${modeloId}/duplicar`, {
      unidadeDestinoId,
    });
    return response;
  },
};

export const pdt = {
  namespaced: true,
  actions,
  state,
  mutations,
};
